"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M5 0C2.937 0 1.25 1.644 1.25 3.677v12.73c0 2.032 1.687 3.676 3.75 3.676h6.25v3.177c0 .284.167.551.44.67l.003.002A.802.802 0 0 0 12 24a.75.75 0 0 0 .479-.174l4.787-3.743H19c2.063 0 3.75-1.644 3.75-3.677V3.677C22.75 1.644 21.063 0 19 0H5ZM2.75 3.677C2.75 2.47 3.753 1.48 5 1.48h14c1.247 0 2.25.99 2.25 2.198v12.73c0 1.207-1.003 2.197-2.25 2.197h-2a.727.727 0 0 0-.478.174l-3.772 2.933v-2.357a.74.74 0 0 0-.75-.74H5c-1.247 0-2.25-.99-2.25-2.198V3.677Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.708 8.712a1.001 1.001 0 1 0-1.415 0A.973.973 0 0 0 8.01 9c.267 0 .513-.103.718-.288h-.02Zm6.582-1.419a1.015 1.015 0 0 0 0 1.42A.958.958 0 0 0 16 9c.264 0 .508-.103.71-.288a1.015 1.015 0 0 0 0-1.419.984.984 0 0 0-1.4 0h-.02Zm1.154 3.94a.742.742 0 0 0-.602.064c-3.774 2-7.644.022-7.687 0a.794.794 0 0 0-1.064.323.784.784 0 0 0 .333 1.064c.215.118 2.14 1.097 4.73 1.097a9.26 9.26 0 0 0 4.43-1.097.785.785 0 0 0 .322-1.064.745.745 0 0 0-.473-.387h.011Z"
  })]
});